import { TaggedDataSetReference } from 'libs/end-to-end/src/types/databases/data-sets/data-set-reference';
import { CompositeDataSetReportInDataSet } from 'libs/end-to-end/src/types/databases/data-sets/composite-data-set-config';
import { z } from 'zod';

export const StartCompositeDataSetGenerateInsightsInput = z.object({
  taggedDataSetReferences: z.array(TaggedDataSetReference),
  reports: z.array(CompositeDataSetReportInDataSet),
});

export type StartCompositeDataSetGenerateInsightsInput = z.infer<
  typeof StartCompositeDataSetGenerateInsightsInput
>;
